import Entity from "./Entity";

export default class Obstacle extends Entity {

    get collider() {
        return this._collider;
    }

    constructor(anchor, texture, altTexture) {
        super(anchor, texture);

        this._altTexture = altTexture;

        this._activated = false;

        this._collider = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._collider.tint = 0xff0000;
        this._collider.anchor.set(0.5, 1);
        this._collider.width = 60;
        this._collider.height = 80
        this._collider.renderable = false;
        this.addChild(this._collider);

    }

    setCollider(x, y, width, height) {
        this._collider.x = x;
        this._collider.y = y;
        this._collider.width = width;
        this._collider.height = height;
    }

    hit() {
        if (!this._activated) {
            this._view.texture = this._altTexture;
            this._activated = true;
        }
    }

}